import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'widget-modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  @Input() dismiss;
  @Output() showModal = new EventEmitter<boolean>();

  cancel(): void {
    this.dismiss();
    if (document.querySelector('body').classList.contains('modal-container__fullpage')) {
      document.querySelector('body').classList.remove('modal-container__fullpage');
    }
  }

  closeModal(): void {
    this.showModal.emit(false);
  }
}
